// extracted by mini-css-extract-plugin
export default {"container":"Manager_container__g7tQx"};